<template>
  <v-app>
    <v-app-bar style="z-index: 5;"
               color="primary"
               app>
      <v-container fluid
                   px-3>
        <v-layout row
                  pa-0>
          <v-flex xs10
                  md2>
            <router-link to="/">
              <v-toolbar-title class="headline text-uppercase white--text">
                <span>PORTAL RDF</span>
              </v-toolbar-title>
            </router-link>
          </v-flex>
          <v-flex offset-md8
                  xs2>
            <a href="https://sipam.gov.pl"
               class="float-right"
               target="_blank">
              <v-toolbar-title class="headline text-uppercase white--text">
                <span>SIPAM</span>
              </v-toolbar-title>
            </a>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
    <v-footer color="primary">
      <v-container fill-height>
        <v-layout row
                  wrap
                  class="align-center justify-center">
          <v-flex md3
                  xs12
                  class="text-xs-center">
            <v-img :src="require('@/assets/logo_1fundusze.svg')" />
          </v-flex>
          <v-flex md1
                  xs12
                  class="text-xs-center">
            <v-img width="80%"
                   style="margin: auto;"
                   :src="require('@/assets/umg.png')" />
          </v-flex>
          <v-flex md3
                  ma-5
                  xs12
                  class="text-xs-center">
            <v-img width="80%"
                   style="margin: auto;"
                   :src="require('@/assets/logo_ministerstwo.png')" />
          </v-flex>
          <v-flex md1
                  xs12
                  class="text-xs-center">
            <v-img width="80%"
                   style="margin: auto;"
                   :src="require('@/assets/ums.png')" />
          </v-flex>
          <v-flex md3
                  xs12
                  class="text-xs-center">
            <v-img :src="require('@/assets/logo_3ue.svg')" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>
